import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PayrollRunForm } from '../components/PayrollRunForm';
import { useCreateRun } from '../queries';
import type { PayrollRunInput } from '../types';

export function PayrollFormPage() {
  const navigate = useNavigate();
  const create = useCreateRun();

  async function handleSubmit(values: PayrollRunInput) {
    const run = await create.mutateAsync(values);
    navigate(`/finance/payroll/${run.public_id}`);
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/finance/payroll')}>
          <ArrowLeft />
        </Button>
        <h1 className="text-2xl font-semibold tracking-tight">New payroll run</h1>
      </div>

      <PayrollRunForm
        submitLabel="Create run"
        onSubmit={handleSubmit}
        onCancel={() => navigate('/finance/payroll')}
      />
    </div>
  );
}
